import React from 'react'

interface IProps {
  width: string
  height: string
  className?: string
  fill: string
  viewBox: string
  children: React.ReactNode
}

const SvgIcon = ({ width, height, className, fill, viewBox, children }: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      className={className}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  )
}

export default SvgIcon